// @flow
import React from 'react'
import styled from 'styled-components'
import {observer} from 'mobx-react'

import Block from 'config/Block'
import Feature from 'config/Feature'
import GridMediaToggle from 'config/GridMediaToggle'
import GridGap from 'config/GridGap'
import CopyAllComponents from 'config/CopyAllComponents'
import CopySingleComponent from 'config/CopySingleComponent'
import CloneStory from 'config/CloneStory'
import CloneGrid from 'config/CloneGrid'
import CopySameLocaleComponent from 'config/CopySameLocaleComponent'
import * as cf from 'cf'


export default observer(function Config () {
  const story = cf.getStory()
  const [isSmall, setIsSmall] = React.useState(story.GRID_GAP['MOBILE_M'] === 10)

  const handleGapClick = (size:string) => () => {
    let GRID_GAP = {
      MOBILE_M:  10,
      MOBILE_L:  15,
      TABLET:    15,
      LAPTOP:    16,
      LAPTOP_L:  23,
      LAPTOP_XL: 29
    }
    if(size === 'big') GRID_GAP = {
      MOBILE_M:  30,
      MOBILE_L:  30,
      TABLET:    35,
      LAPTOP:    35,
      LAPTOP_L:  40,
      LAPTOP_XL: 45
    }
    
    cf.update(Object.assign({}, story, { GRID_GAP}))
    setIsSmall(size === 'small')
  }

  return (
    <Wrapper className='Config'>
      <Block headline='Media Sizes'>
          <Feature title='Mobile M (< 375px)'><GridMediaToggle static gridName='MOBILE_M' /></Feature>
          <Feature title='Mobile L (> 375px)'><GridMediaToggle gridName='MOBILE_L' /></Feature>
          <Feature title='Tablet (> 525px)'><GridMediaToggle gridName='TABLET' /></Feature>
          <Feature title='Laptop (> 768px)'><GridMediaToggle gridName='LAPTOP' /></Feature>
          <Feature title='Laptop L (> 990px)'><GridMediaToggle gridName='LAPTOP_L' /></Feature>
          <Feature title='Laptop XL (> 1200px)'><GridMediaToggle gridName='LAPTOP_XL' /></Feature>
      </Block>
      <Block headline='Grid Gap'>
        <Gaps>
          <GapButton selected={isSmall} onClick={handleGapClick('small')}>Small</GapButton>
          <GapButton selected={!isSmall} onClick={handleGapClick('big')}>Big</GapButton>
        </Gaps>
      </Block>
      <Block headline='Copy Components'>
        <Feature title='Clone All'><CopyAllComponents/></Feature>
        <Feature title='Clone Component'><CopySingleComponent/></Feature>
        <Feature title='Clone own Component'><CopySameLocaleComponent/></Feature>
        <Feature title='Clone Story'><CloneStory/></Feature>
      </Block>
      <Block headline='Grid'>
        <Feature title='Clone Grid'><CloneGrid/></Feature>
      </Block>
      <div style={{height:500}} />
    </Wrapper>
  )
})

const Wrapper = styled.div`
  height: 100%;
  margin: 0 auto;
  padding: 10px;
  margin-bottom: 100px;
  padding-bottom: 200px;
`

const Gaps = styled.div`
  display: flex;
  height: 100px;
  align-items: center;
  justify-content: flex-start;
  padding-left: 100px;
`

const GapButton = styled.div`
  padding: 10px 15px;
  border: 2px solid #555;
  background: none;
  color: #555;
  border-radius: 5px;
  text-transform: uppercase;
  margin-right: 20px;
  cursor: pointer;

  ${p => p.selected && `
    background: #555;
    color: white;
  `}
`


// WEBPACK FOOTER //
// ./src/routes/Config.js